import { Route } from "@dashboard/components/Router";
import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";

import { cmsPageAddPath, cmsPagePath, cmsPagesListPath } from "./urls";
import CmsPageDetails from "./views/CmsPageDetails";
import CmsPagesList from "./views/CmsPagesList";

const CmsPageDetailsRoute = ({ match }: RouteComponentProps<{ id: string }>) => (
  <CmsPageDetails id={decodeURIComponent(match.params.id)} />
);

const CmsPagesSection = () => (
  <Switch>
    <Route exact path={cmsPagesListPath} component={CmsPagesList} />
    <Route exact path={cmsPageAddPath} render={() => <CmsPageDetails />} />
    <Route path={cmsPagePath(":id")} component={CmsPageDetailsRoute} />
  </Switch>
);

export default CmsPagesSection;
